import Vue from 'vue';
import { gameStore } from '@/store/game/store';
import { ActionMode, Action, CardCategory } from '@/store/game';
import { Client } from '@/client';
import _ from 'lodash';
import { getCardFilename } from '@/functions';
export default Vue.extend({
    data() {
        return {
            personIndex: 0,
            locationIndex: 0,
            weaponIndex: 0
        }
    },
    computed: {
        visible() {
            return gameStore.state.ui.showAccuseDlg;
        },
        glassBeneficiary() {
            const ben = gameStore.glassBeneficiary;
            return ben ? `a ${ben.name}` : "al tavolo";
        },
        persons() {
            const allPersons = _.filter(gameStore.state.allDeckCards, c => c.category == CardCategory.Person);
            const potentialAccused = _.reject(allPersons, p => _.some(gameStore.playerSeeableCards, c => c.category == CardCategory.Person && c.number == p.number));

            return _.orderBy(potentialAccused, a => a.number);
        },
        locations() {
            const allLocations = _.filter(gameStore.state.allDeckCards, c => c.category == CardCategory.Location);
            const potentialAccused = _.reject(allLocations, p => _.some(gameStore.playerSeeableCards, c => c.category == CardCategory.Location && c.number == p.number));

            return _.orderBy(potentialAccused, a => a.number);
        },
        weapons() {
            const allWeapons = _.filter(gameStore.state.allDeckCards, c => c.category == CardCategory.Weapon);
            const potentialAccused = _.reject(allWeapons, p => _.some(gameStore.playerSeeableCards, c => c.category == CardCategory.Weapon && c.number == p.number));

            return _.orderBy(potentialAccused, a => a.number);
        }
    },
    methods: {
        dismiss() {
            gameStore.commitToggleAccuseDlg(false);
        },
        accuse() {
            Client.getInstance().send({
                action: Action.accuse,
                cards: [
                    this.persons[this.personIndex],
                    this.locations[this.locationIndex],
                    this.weapons[this.weaponIndex]
                ]
            });
            this.dismiss();
        },
        setPerson(index: number) {
            this.personIndex = index;
        },
        setLocation(index: number) {
            this.locationIndex = index;
        },
        setWeapon(index: number) {
            this.weaponIndex = index;
        },
    }
})
